"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
const errors_1 = require("../errors");
const typed_countries_1 = require("./typed-countries");
exports.getAssetType = (assetTypeLike) => {
    let assetType;
    if (assetTypeLike.toLowerCase() == "producer")
        assetType = constants_1.PRODUCER_ASSET_TYPE;
    else if (assetTypeLike.toLowerCase() == "consumer")
        assetType = constants_1.CONSUMER_ASSET_TYPE;
    else if (assetTypeLike.toLowerCase() == "prosumer")
        assetType = constants_1.PROSUMER_ASSET_TYPE;
    else if (assetTypeLike.toLowerCase() == "product")
        assetType = constants_1.PRODUCT_ASSET_TYPE;
    else {
        const assetTypeRaw = parseInt(assetTypeLike);
        if (assetTypeRaw
            == constants_1.PRODUCER_ASSET_TYPE
            || assetTypeRaw
                == constants_1.CONSUMER_ASSET_TYPE
            || assetTypeRaw
                == constants_1.PROSUMER_ASSET_TYPE) {
            assetType = assetTypeRaw;
        }
        else {
            console.error("Incorrect asset type provided!", { assetTypeLike: assetTypeLike });
            throw new Error("Incorrect asset type provided!");
        }
    }
    return assetType;
};
exports.getCountryISO = (country) => {
    const result = typed_countries_1.countries.find(c => c.name.toLowerCase() === country.toLowerCase());
    if (!result)
        return;
    return result.iso;
};
exports.getMatchingResolution = (resolution) => {
    switch (resolution) {
        case "1h":
            return 60;
        case "1day":
            return 1440;
        case "15min":
            return 15;
        default:
            throw new Error("Matching resolution not found. Available: 15min, 1h, 1day.");
    }
};
exports.normalizeParams = (filter) => {
    if (typeof filter.chainId === "string") {
        switch (filter.chainId) {
            case 'parity:flexidao':
                filter.chainId = 17;
                break;
            case 'ganache:flexidao':
                filter.chainId = 111111;
                break;
            case 'tobalaba':
                filter.chainId = 401697;
                break;
            default:
                throw new Error(errors_1.Errors.chainIdNotFound);
        }
    }
    return filter;
};
